<!-- Tokens and CSS colors disambiguate themselves: for a token the inline styles
     are invalid CSS (dropped by the browser) and its class applies; for a CSS
     color no class matches and the inline styles apply (~5% tint background,
     same pale pattern as the token classes). -->
<span
  class="status-indicator"
  [class]="color"
  [style.color]="color"
  [style.background]="'color-mix(in srgb, ' + color + ' 5%, white)'"
>
  {{ text }}
</span>
